import { Box, styled, useTheme } from "@mui/material";
import { Outlet as RouterOutlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import FixedAppBar from "components/layout/FixedAppBar";
import FixedBottomMenu from "components/layout/FixedBottomMenu";
import { getApplicationUserEdit } from "store/slices/user/userSlice";
import { oidcUserManager } from "config/authentication";
import useDispatch from "hooks/useDispatch";

export default function MobileLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();

  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setPageLoading(true);

    oidcUserManager
      .getUser()
      .then((user) => {
        if (!user) {
          navigate("/welcome");
        } else {
          dispatch(getApplicationUserEdit());
        }
      })
      .finally(() => {
        setPageLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ background: theme.palette.background.main, minHeight: "100vh" }}>
      {!pageLoading && (
        <>
          <FixedAppBar />

          <ContentWrapper>
            <RouterOutlet />
          </ContentWrapper>

          <FixedBottomMenu />
        </>
      )}
    </Box>
  );
}

const ContentWrapper = styled(Box)(({ theme }) => ({
  minHeight: "calc(100vh - 106px)",
  padding: "50px 0 78px",
  background: theme.palette.background.paper,
}));
